export const GET_LIVE_SCHEDULE = 'GET_LIVE_SCHEDULE'
export const UPDATE_CURRENT_LIVE = 'UPDATE_CURRENT_LIVE'
export const SET_ACTIVE_RIBBON = 'SET_ACTIVE_RIBBON'
export const UPDATE_LIVE_PAGE = 'UPDATE_LIVE_PAGE'
export const SET_VOLUME_LIVE = 'SET_VOLUME_LIVE'
